export const projectInformationArray = [
  {
    name: "Revolutionary Revelations",
    description:
      "Created a visual identity for a seven-part series about Thomas Jefferson that felt authentic to the era with modern details. Focused on clear reader navigation between stories online and consistency across all products, both print and digital. Illustrations by Ricardo Martinez.",
    skills: "Web development, Digital design, Art direction, Print design",
    awards: [
      {
        award:
          "Bronze Medal for Commissioned Illustrations from the Society for News Design",
      },
      {
        award:
          "Bronze Medal for National Line of Coverage from the Society for News Design",
      },
    ],

    stories: [
      {
        headline: "Author of a revelation",
        url: "https://www.washingtonpost.com/politics/interactive/2025/thomas-jefferson-american-revolution/",
      },

      {
        headline: "Norfolk must be destroyed",
        url: "https://www.washingtonpost.com/politics/interactive/2025/thomas-jefferson-battle-norfolk-burning/",
      },
      {
        headline: "Building the case against Britain",
        url: "https://www.washingtonpost.com/politics/interactive/2025/thomas-jefferson-freedom-taxes-property/",
      },
      {
        headline: "The paradox of Philadelphia",
        url: "https://www.washingtonpost.com/politics/interactive/2025/thomas-jefferson-philadelphia-declaration-independence-slavery/",
      },
      {
        headline: "Jefferson's retreat and return to power",
        url: "https://www.washingtonpost.com/politics/interactive/2025/thomas-jefferson-virginia-governor-british/",
      },
      {
        headline: "How Jefferson's words were doctored in his memorial",
        url: "https://www.washingtonpost.com/politics/interactive/2025/thomas-jefferson-memorial-writings-slavery/",
      },
      {
        headline: "The Declaration that changed America and the world",
        url: "https://www.washingtonpost.com/politics/interactive/2025/thomas-jefferson-declaration-freedom-slavery/",
      },
    ],
    visuals: [
      {
        type: "image",
        source: "/projects/jefferson/jefferson-chapter1-sm.jpg",
        alt: ``,
      },
      {
        type: "image",
        source: "/projects/jefferson/jefferson-chapter4-sm.jpg",
        alt: ``,
      },
      {
        type: "image",
        source: "/projects/jefferson/jefferson-chapter6-sm.jpg",
        alt: ``,
      },
      {
        type: "video",
        source: "/projects/jefferson/jefferson-chapter6.mp4",
      },
      {
        type: "image",
        source: "/projects/jefferson/jefferson-cover.png",
        pagetype: "single",
      },
      {
        type: "image",
        source: "/projects/jefferson/jefferson-spread.png",
        pagetype: "double",
      },
      {
        type: "image",
        source: "/projects/jefferson/jefferson-mobile-1.png",
        altText: ``,
        pagetype: "mobile",
      },
      {
        type: "image",
        source: "/projects/jefferson/jefferson-mobile-2.png",
        altText: ``,
        pagetype: "mobile",
      },
      {
        type: "image",
        source: "/projects/jefferson/jefferson-mobile-3.png",
        altText: ``,
        pagetype: "mobile",
      },
    ],
  },
  {
    name: "The Money War",
    description:
      "Designed a cohesive visual language for a seven-part series about the rise of sanctions in U.S. foreign policy. Worked with key stakeholders across design, graphics and photo to ensure all elements felt fitting in the series. Juggled stories that needed to be told in different formats, identifying the best method of storytelling for each piece. Illustrations by Chantal Jahchan and Kyle Ellingson.",
    skills: "Web development, Digital design, Art direction, Print design",
    awards: [
      { award: "Gerald Loeb Award in the International category" },
      {
        award:
          "Award of Excellence for Investigative Special Coverage from the Society for News Design",
      },
    ],

    stories: [
      {
        headline:
          "How four U.S. presidents unleashed economic warfare across the globe",
        url: "https://www.washingtonpost.com/business/interactive/2024/us-sanction-countries-work/",
      },

      {
        headline:
          "Washington targeted ‘corrupt’ mines. Workers paid the greatest price.",
        url: "https://www.washingtonpost.com/business/interactive/2024/us-sanctions-guatemala-nickel-mine-el-estor-workers/",
      },
      {
        headline:
          "A new Washington influence industry is making millions from sanctions",
        url: "https://www.washingtonpost.com/business/interactive/2024/us-sanctions-lobbying-money-washington-lebanon-venezuela/",
      },
      {
        headline:
          "How a Russian oligarch’s $90 million megayacht landed in U.S. custody",
        url: "https://www.washingtonpost.com/business/interactive/2024/us-sanctions-work-russian-oligarch-yacht-seized/",
      },
      {
        headline: "The U.S. seized a Russian yacht. Now you’re paying for it.",
        url: "https://www.washingtonpost.com/business/interactive/2024/russian-sanctions-oligarch-yacht-us-taxpayers/",
      },
    ],
    visuals: [
      {
        type: "video",
        source: "/projects/moneywar/overview-video.mp4",
      },
      {
        type: "image",
        source: "/projects/moneywar/upkeep-a1-mock.png",
        alt: ``,
      },
      {
        type: "image",
        source: "/projects/moneywar/upkeep-spread.png",
        alt: ``,
        pagetype: "double",
      },
      {
        type: "image",
        source: "/projects/moneywar/sanctions-mobile-1.png",
        altText: ``,
        pagetype: "mobile",
      },
      {
        type: "image",
        source: "/projects/moneywar/sanctions-mobile-2.png",
        altText: ``,
        pagetype: "mobile",
      },
      {
        type: "image",
        source: "/projects/moneywar/sanctions-mobile-3.png",
        altText: ``,
        pagetype: "mobile",
      },

      {
        type: "image",
        source: "/projects/moneywar/navigator-mock.png",
        alt: ``,
        pagetype: "single",
      },
      {
        type: "image",
        source: "/projects/moneywar/guatemala-spread.png",
        alt: ``,
        pagetype: "double",
      },
      {
        type: "video",
        source: "/projects/moneywar/navigator-video.mp4",
      },
    ],
  },
  {
    name: "Crossroads of Conflict",
    description:
      "A collection of profiles of people living in the Sahel region of Africa. Collaborated with Tyler Remmel to create an immersive experience that highlighted the strong photography and allowed for easy navigation between the profiles.",
    skills: "Digital design, Web development, Print design",
    awards: [
      {
        award:
          "Award of Excellence for International Story Page Design from the Society for News Design",
      },
      {
        award:
          "Award of Excellence for International Line of Coverage from the Society for News Design",
      },
    ],
    stories: [
      {
        headline: "Crossroads of conflict",
        url: "https://www.washingtonpost.com/world/interactive/2025/africa-sahel/russian-terror-military-influence/",
      },

      {
        headline: "The Islamist militant",
        url: "https://www.washingtonpost.com/world/interactive/2025/africa-sahel/islam-jihad-extremist-movement/",
      },
      {
        headline: "The militia commander",
        url: "https://www.washingtonpost.com/world/interactive/2025/africa-sahel/militias-islamic-extremism-violence/",
      },
      {
        headline: "The Russian mercenary",
        url: "https://www.washingtonpost.com/world/interactive/2025/africa-sahel/russian-influence-putin-wagner-group/",
      },
      {
        headline: "The American soldier",
        url: "https://www.washingtonpost.com/world/interactive/2025/africa-sahel/american-military-foreign-threats/",
      },
      {
        headline: "The coup leader",
        url: "https://www.washingtonpost.com/world/interactive/2025/africa-sahel/military-coups-african-nations-sovereignty/",
      },
      {
        headline: "The defiant broadcaster",
        url: "https://www.washingtonpost.com/world/interactive/2025/africa-sahel/journalism-media-threats-democracy/",
      },
    ],
    visuals: [
      {
        type: "video",
        source: "/projects/crossroads/crossroads.mp4",
      },
      {
        type: "image",
        source: "/projects/crossroads/crossroads-cover.png",
        altText: ``,
      },
      {
        type: "image",
        source: "/projects/crossroads/crossroads-spread.png",
        altText: ``,
        pagetype: "double",
      },
      {
        type: "video",
        source: "/projects/crossroads/coup-leader.mp4",
      },
    ],
  },
  {
    name: "Total solar eclipse coverage",
    description:
      "Designed the branding for The Post's coverage of the 2024 total solar eclipse by pitching a color palette, logo, landing page and special section. Coordinated across the design team and other desks in the newsroom to ensure all coverage was in line with our brand. Also designed and developed several stories about the eclipse. Collaborated with Emily Sabens. Illustrations by Evan Cohen and Lauren Martin.",
    skills:
      "Branding, Web development, Digital design, Art direction, Print design",
    awards: [
      {
        award:
          "Award of Excellence for Regional/Local Special Coverage from the Society for News Design",
      },
    ],
    stories: [
      {
        headline: "Overview of eclipse design",
        url: "https://www.instagram.com/p/C5jbrm8P3_4/?img_index=1",
      },

      {
        headline: "Are you in the dark about the eclipse? Take our quiz.",
        url: "https://www.washingtonpost.com/nation/interactive/2024/tolar-solar-eclipse-quiz/",
      },
      {
        headline: "See how the eclipse transformed America, city by city",
        url: "https://www.washingtonpost.com/weather/interactive/2024/solar-eclipse-photos-videos-totality-us/",
      },
    ],
    visuals: [
      {
        type: "video",
        source: "/projects/eclipse/eclipseviz.mp4",
      },
      {
        type: "image",
        source: "/projects/eclipse/eclipse-1.png",
        altText: ``,
        pagetype: "single",
      },
      {
        type: "image",
        source: "/projects/eclipse/eclipse-2.png",
        altText: ``,
        pagetype: "double",
      },
      {
        type: "animation",
        source: "/projects/eclipse/eclipse-quiz.mp4",
        altText: ``,
        pagetype: "double",
      },
      {
        type: "image",
        source: "/projects/eclipse/eclipse-spots.png",
        altText: ``,
        pagetype: "single",
      },
    ],
  },
  {
    name: "Youth Crime in D.C.",
    description:
      "A four-part series about youth crime in D.C. Art directed a series of three illustrations with a unifying clock motif and consistent color palette. Designed and developed a thoughtful way to display documents in a screen-reader and mobile-friendly format. Illustrations by Sally Deng. Collaborated with Carson TerBush.",
    skills: "Web development, Art direction, UX design, Print design",
    awards: [
      {
        award: "Bronze for Use of Video from the Society for News Design",
      },
      {
        award:
          "Award of Excellence for Commissioned Illustrations from the Society for News Design",
      },
    ],
    stories: [
      {
        headline: "Empty desks",
        url: "https://www.washingtonpost.com/investigations/interactive/2025/dc-schools-truancy-youth-crime/",
      },

      {
        headline: "On the box",
        url: "https://www.washingtonpost.com/investigations/interactive/2025/dc-juvenile-court-gps-monitors-crime/",
      },
      {
        headline: `Serving ‘dead time’`,
        url: "https://www.washingtonpost.com/investigations/interactive/2025/dc-dyrs-youth-crime-rehabilitation/",
      },
    ],
    visuals: [
      {
        type: "animation",
        source: "/projects/artdirection/dcyouth-truancy.mp4",
      },
      {
        type: "animation",
        source: "/projects/artdirection/dcyouth-dyrs.mp4",
      },

      {
        type: "image",
        source: "/projects/dcyouth/dcyouth-mobile-1.png",
        altText: ``,
        pagetype: "mobile",
      },
      {
        type: "image",
        source: "/projects/dcyouth/dcyouth-mobile-2.png",
        altText: ``,
        pagetype: "mobile",
      },
      {
        type: "image",
        source: "/projects/dcyouth/dcyouth-mobile-3.png",
        altText: ``,
        pagetype: "mobile",
      },
      {
        type: "image",
        source: "/projects/dcyouth/dcyouth-print.png",
        altText: ``,
        pagetype: "double",
      },
    ],
  },
  // {
  //   name: "2023 was District’s deadliest year in more than two decades",
  //   description:
  //     "A year-end story about the homicides in D.C. in 2023. Illustrations by Janelle Washington.",
  //   skills: "Web development, Digital design, Art direction, Print design",
  //   awards: [],
  //   link: "https://www.washingtonpost.com/dc-md-va/interactive/2024/dc-crime-homicide-victims-shooting-violence/",
  //   visuals: [
  //     {
  //       type: "video",
  //       source: "projects/dchomicides/dchomicides.mp4",
  //     },
  //     {
  //       type: "image",
  //       source: "projects/dchomicides/dchomicides-1.png",
  //       altText: ``,
  //       pagetype: "double",
  //     },
  //     {
  //       type: "image",
  //       source: "projects/dchomicides/dchomicides-2.png",
  //       altText: ``,
  //       pagetype: "double",
  //     },
  //   ],
  // },
];
